__turbopack_context__.v({
  "answer": "questions-and-answers-module-scss-module__abrkLa__answer",
  "cards": "questions-and-answers-module-scss-module__abrkLa__cards",
  "description": "questions-and-answers-module-scss-module__abrkLa__description",
  "faq": "questions-and-answers-module-scss-module__abrkLa__faq",
  "group": "questions-and-answers-module-scss-module__abrkLa__group",
  "group-label": "questions-and-answers-module-scss-module__abrkLa__group-label",
  "groups": "questions-and-answers-module-scss-module__abrkLa__groups",
  "heading": "questions-and-answers-module-scss-module__abrkLa__heading",
  "inner": "questions-and-answers-module-scss-module__abrkLa__inner",
  "intro": "questions-and-answers-module-scss-module__abrkLa__intro",
  "panels": "questions-and-answers-module-scss-module__abrkLa__panels",
});
